import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { Separator } from '@change/ds-core-ui/Separator';

import { Translate } from '@change-corgi/core-react/i18n';

import { SocialProof } from '#src/app/pages/petitionDetails/shared/components';
import { useNextStepButtonAction } from '#src/app/pages/petitionDetails/shared/hooks';

import { SignatureStatsActive } from '../Stats';

export const SideSignedPromotable: React.FC<EmptyProps> = () => {
	const {
		data: { comboLink },
		action: { handleNextStepClick },
	} = useNextStepButtonAction();

	return (
		<div className="flex flex-col gap-6">
			<SignatureStatsActive />
			<Separator orientation="horizontal" className="border-stroke-weak" />
			<SocialProof />
			<Button
				variant="primary"
				as="a"
				href={comboLink}
				onClick={handleNextStepClick}
				data-qa="signed-petition-combo-cta"
				className="w-full"
			>
				<Translate value="fe.pages.petition_update.combo_action_button_label" />
			</Button>
		</div>
	);
};
